import { render } from "./ProfileSideNav.vue?vue&type=template&id=63e15992"
import script from "./ProfileSideNav.vue?vue&type=script&lang=js"
export * from "./ProfileSideNav.vue?vue&type=script&lang=js"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__